var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.58496V12.5C19 16.272 19 18.157 17.828 19.329C17.02 20.137 15.872 20.388 14 20.465M3 7.58496V12.5C3 16.272 3 18.157 4.172 19.329C5.235 20.392 6.886 20.49 10 20.499C10.265 20.499 10.5192 20.3937 10.7068 20.2064C10.8943 20.0191 10.9997 19.765 11 19.5V16.5",
    stroke: "#292929",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.5L16.657 5.336C13.99 2.779 12.657 1.5 11 1.5C9.343 1.5 8.01 2.78 5.343 5.336L1 9.5M13.001 8V10.5M9.001 10.5V8M7.506 11.38C7.466 10.905 7.876 10.5 8.396 10.5H13.61C14.13 10.5 14.54 10.905 14.5 11.38L14.393 12.678C14.312 13.6214 13.973 14.5244 13.413 15.288L13.063 15.77C12.732 16.226 12.174 16.5 11.577 16.5H10.429C9.832 16.5 9.274 16.226 8.943 15.77L8.593 15.288C8.03304 14.5244 7.694 13.6214 7.613 12.678L7.506 11.38Z",
    stroke: "#292929",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilities);
export default __webpack_public_path__ + "static/media/utilities.ed3edc3840fd8d0db59d361384486197.svg";
export { ForwardRef as ReactComponent };